// International phone: must start with +, then 6–18 digits/spaces/dashes/dots/parens
const PHONE_REGEX = /^\+[\d\s\-().]{6,18}$/;

export function isValidPhone(phone: string): boolean {
  return PHONE_REGEX.test(phone);
}
